module.exports = __webpack_public_path__ + "static/inflybo-798d6922f770552d2427e4de11322315.png";